export default {
  setTeamMembersLoading: ({ teamMembers }, payload) => {
    teamMembers.loading = payload;
  },
  loadTeamMembersSuccess: ({ teamMembers }, payload) => {
    teamMembers.items = payload.data;
    teamMembers.loading = false;
    teamMembers.pagination.totalItems = payload.recordsTotal;
  },
  setTeamMembersPagination: ({ teamMembers }, payload) => {
    teamMembers.pagination = payload;
  },
};
